/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/context/context.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { Features } from "./features";
import { Server } from "./server";
import { Vhost } from "./vhost";
import * as i0 from "@angular/core";
/** @type {?} */
export const featuresFactory = (/**
 * @return {?}
 */
() => Features.fromBody());
/** @type {?} */
export const serverFactory = (/**
 * @return {?}
 */
() => Server.fromBody());
/** @type {?} */
export const vhostFactory = (/**
 * @return {?}
 */
() => Vhost.fromBody());
export class ContextModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: ContextModule,
            providers: [
                { provide: Features, useFactory: featuresFactory },
                { provide: Server, useFactory: serverFactory },
                { provide: Vhost, useFactory: vhostFactory },
            ],
        };
    }
}
ContextModule.decorators = [
    { type: NgModule },
];
/** @nocollapse */ ContextModule.ɵmod = i0.ɵɵdefineNgModule({ type: ContextModule });
/** @nocollapse */ ContextModule.ɵinj = i0.ɵɵdefineInjector({ factory: function ContextModule_Factory(t) { return new (t || ContextModule)(); } });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ContextModule, [{
        type: NgModule
    }], null, null); })();
//# sourceMappingURL=data:application/json;base64,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